import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Stack,
  TextField,
  FormGroup,
  Button,
  Typography,
  Modal,
  MenuItem,
} from "@mui/material";
import FilterDrawer from "../../../../../components/FilterDrawer/FilterDrawer";
import ClearFilter from "../../../../../components/ClearFilter/ClearFilter";
import FilterTypeWrap from "../../../../../components/FilterDrawer/FilterTypeWrap";
import FilterLabel from "../../../../../components/FilterDrawer/FilterLabel/FilterLabel";
import FilterCheckBoxWrap from "../../../../../components/FilterDrawer/FilterCheckBoxWrap";
import FilterCheckbox from "../../../../../components/FilterDrawer/FilterCheckbox/FilterCheckbox";
import FilterChipsWrap from "../../../../../components/FilterDrawer/FilterChips/FilterChipsWrap";
import FilterChips from "../../../../../components/FilterDrawer/FilterChips/FilterChips";
import styles from "./TaskKanbanHeader.module.css";
import UserAvatarGroup from "../../../../../components/UserAssign/UserAvatarGroup";
import moment from "moment";
import { useAuthUser } from "react-auth-kit";
import getAccessStatus from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import { useSelector } from "react-redux";
import Remainder from "../../../../../assets/images/remainder.svg";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import DateRangePicker from "../../../../../components/DateRangePicker/DateRangePicker";
import AddIcon from "@mui/icons-material/Add";
import AddTask from "../../../Nurture/components/AddTask/AddTask";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import TaskCreation from "../../../../../components/TaskCreation/TaskCreation";
import { formatTaskCategory } from "../../../../../components/CommonFunctions/CommonFunctions";

function TaskKanbanHeader(props: any) {
  const {
    handleFilterTasks,
    handleLeadSearch,
    leadSearchTerm,
    tasksTypes,
    filteredValue,
    filterCheckedTypes,
    filterCheckedPriorities,
    filterCheckedCategories,
    selectedTeamMember,
    setSelectedTeamMember,
    taskBoardApiCall,
    rangeStartDate,
    setIsOpen,
    filterStartDate,
    setFilterStartDate,
    filterEndDate,
    setFilterEndDate,
    onFilterDateChange,
    setCardType,
    setTextForReminder,
    taskCountCall,
    CreateTask,
    EditTask,
    UpdateTaskStatus,
    DeleteTask,
    selectedLeadData,
    leadTaskList,
    employees,
    taskTypes,
    CreateComment,
    DeleteComment,
    EditComment,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const navigate = useNavigate();
  const location = useLocation();
  const { userById } = useSelector((state: any) => state.userDetails);

  const hasAllTaskAccess = getAccessStatus(
    "TASKS",
    "ALL_OTHER_USERS'_TASK",
    userById?.rolePermission,
  );
  const staffList = useSelector((state: any) => state.staff.staffList);
  const instituteData = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);

  const [filterApplied, setFilterApplied] = React.useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = React.useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [showAddTask, setShowAddTask] = useState(false);
  const [fromTaskEdit, setFromTaskEdit] = useState<boolean>(false);
  const [taskForEditing, setTaskForEditing] = useState<any>();
  const [taskTypeValue, setTaskTypeValue] = useState<any>(null);
  const [assigneeValue, setAssigneeValue] = useState<any>(null);

  interface CheckedPriorities {
    priority: string;
  }
  interface CheckedTypes {
    type: string;
  }
  interface CheckedCategories {
    category: string;
  }

  const [checkedPriorities, setCheckedPriorities] = useState<
    CheckedPriorities[]
  >([]);

  const [checkedTypes, setCheckedTypes] = useState<CheckedTypes[]>([]);

  const [checkedCategories, setCheckedCategories] = useState<
    CheckedCategories[]
  >([]);

  const handleFilterPriorityChecked = (priority: string) => {
    const priorityToAdd: CheckedPriorities = { priority };

    if (
      checkedPriorities.some(
        (item) => item.priority.toLowerCase() === priority.toLowerCase(),
      )
    ) {
      setCheckedPriorities(
        checkedPriorities.filter(
          (item) => item.priority.toLowerCase() !== priority.toLowerCase(),
        ),
      );
    } else {
      setCheckedPriorities([...checkedPriorities, priorityToAdd]);
    }
  };

  const clearCheckedPriority = (priority: string) => {
    setCheckedPriorities(
      checkedPriorities.filter(
        (item) => item.priority.toLowerCase() !== priority.toLowerCase(),
      ),
    );
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const toggleShowAddTask = () => {
    setShowAddTask(!showAddTask);
    setFromTaskEdit(false);
  };

  const handleFilterTypeChecked = (type: string) => {
    const typeToAdd: CheckedTypes = { type };

    if (
      checkedTypes.some(
        (item) => item.type.toLowerCase() === type.toLowerCase(),
      )
    ) {
      setCheckedTypes(
        checkedTypes.filter(
          (item) => item.type.toLowerCase() !== type.toLowerCase(),
        ),
      );
    } else {
      setCheckedTypes([...checkedTypes, typeToAdd]);
    }
  };

  const clearCheckedType = (type: string) => {
    setCheckedTypes(
      checkedTypes.filter(
        (item) => item.type.toLowerCase() !== type.toLowerCase(),
      ),
    );
  };

  const handleFilterCategoryChecked = (category: string) => {
    const categoryToAdd: CheckedCategories = { category };

    if (
      checkedCategories.some(
        (item) => item.category.toLowerCase() === category.toLowerCase(),
      )
    ) {
      setCheckedCategories(
        checkedCategories.filter(
          (item) => item.category.toLowerCase() !== category.toLowerCase(),
        ),
      );
    } else {
      setCheckedCategories([...checkedCategories, categoryToAdd]);
    }
  };

  const clearCheckedCategory = (category: string) => {
    setCheckedCategories(
      checkedCategories.filter(
        (item) => item.category.toLowerCase() !== category.toLowerCase(),
      ),
    );
  };

  const handleFilterApply = React.useCallback(() => {
    handleFilterTasks(
      checkedPriorities,
      checkedTypes,
      filterStartDate,
      filterEndDate,
      checkedCategories,
    );

    setFilterApplied(
      checkedPriorities?.length === 0 &&
        checkedTypes?.length === 0 &&
        checkedCategories?.length === 0 &&
        (filterStartDate === null || filterEndDate === null)
        ? false
        : true,
    );
  }, [
    handleFilterTasks,
    checkedPriorities,
    checkedTypes,
    checkedCategories,
    setFilterApplied,
    filterStartDate,
    filterEndDate,
  ]);

  const handleResetClick = React.useCallback(() => {
    handleFilterTasks([], [], null, null, []);
    setCheckedTypes([]);
    setCheckedPriorities([]);
    setCheckedCategories([]);
    setFilterApplied(false);
    setFilterStartDate(new Date());
    setFilterEndDate(null);
  }, [
    handleFilterTasks,
    setFilterApplied,
    setCheckedPriorities,
    setCheckedTypes,
  ]);

  const handleFilterClose = React.useCallback(() => {
    setCheckedTypes(filterCheckedTypes);
    setCheckedPriorities(filterCheckedPriorities);
    setCheckedCategories(filterCheckedCategories || []);
  }, [filterCheckedPriorities, filterCheckedTypes, filterCheckedCategories]);

  const cancelClick = () => {
    setIsOpenFilter(true);
  };

  const closeClearFilter = () => {
    setIsOpenFilter(false);
  };

  const yesButtonClick = () => {
    handleResetClick();
    setIsOpenFilter(false);
    setFilterApplied(false);
  };

  const noButtonClick = () => {
    setIsOpenFilter(false);
  };

  const handleTeamMemberSelect = (emp: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");
    const taskFilterStartDate: any = urlSearchParams.get("taskFilterStartDate");
    const taskFilterEndDate: any = urlSearchParams.get("taskFilterEndDate");
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");
    let startingDate: number | null = null;
    let endingDate: number | null = null;

    if (taskStartDate && taskEndDate) {
      startingDate = Number(taskStartDate);
      endingDate = Number(taskEndDate);
    } else {
      startingDate = moment(rangeStartDate).startOf("day").unix() * 1000;
      endingDate = moment(rangeStartDate).endOf("day").unix() * 1000;
    }

    // --- Multi-select logic ---
    setSelectedTeamMember((prevSelected: any[]) => {
      let updatedSelected;

      // Toggle logic: remove if already selected, otherwise add
      if (prevSelected.some((member) => member.id === emp.id)) {
        updatedSelected = prevSelected.filter((member) => member.id !== emp.id);
      } else {
        updatedSelected = [...prevSelected, emp];
      }

      // ✅ selectedUserIds as an array of strings
      const selectedUserIds: string[] = updatedSelected.map((m) =>
        String(m.id),
      );

      const currentSearchText = taskLeadSearchInUrl || leadSearchTerm || "";

      // --- API call ---
      if (startingDate !== null && endingDate !== null) {
        const formattedCategories =
          filterCheckedCategories?.map((item: any) => ({
            taskCategory: formatTaskCategory(item.category),
          })) || [];

        taskBoardApiCall(
          authUser?.institute?.[0]?.instituteDetails?.id,
          startingDate,
          endingDate,
          selectedUserIds,
          currentSearchText,
          filterCheckedPriorities,
          filterCheckedTypes,
          Number(taskFilterStartDate),
          Number(taskFilterEndDate),
          formattedCategories,
        );
        taskCountCall(
          authUser?.institute?.[0]?.instituteDetails?.id,
          startingDate,
          endingDate,
          selectedUserIds,
          currentSearchText,
          filterCheckedPriorities,
          filterCheckedTypes,
          Number(taskFilterStartDate),
          Number(taskFilterEndDate),
          formattedCategories,
        );
      }

      // --- Update URL params ---
      const queryParams = new URLSearchParams(window.location.search);
      if (selectedUserIds.length > 0) {
        // You can store as comma-separated for URL readability
        queryParams.set("selectedUsers", selectedUserIds.join(","));
      } else {
        queryParams.delete("selectedUsers");
      }

      navigate(
        {
          pathname: location.pathname,
          search: queryParams.toString() ? `?${queryParams.toString()}` : "",
        },
        { replace: false },
      );

      return updatedSelected;
    });
  };

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const priorityParam = urlSearchParams.get("taskPriorities");
    const categoryParam = urlSearchParams.get("taskCategories");
    const taskFilterStartDate: any = urlSearchParams.get("taskFilterStartDate");
    const taskFilterEndDate: any = urlSearchParams.get("taskFilterEndDate");

    if (priorityParam) {
      const priorities = priorityParam.split("|");

      const selectedPriorities = priorities
        .map((value) => {
          const priority = [
            { priority: "URGENT" },
            { priority: "HIGH" },
            { priority: "NORMAL" },
            { priority: "LOW" },
          ].find(
            (type: any) => type.priority.toLowerCase() === value.toLowerCase(),
          );
          return priority
            ? {
                priority: priority.priority,
              }
            : null;
        })
        .filter(Boolean) as CheckedPriorities[];

      setCheckedPriorities(selectedPriorities);
    }

    if (categoryParam) {
      const categories = categoryParam.split("|");

      const selectedCategories = categories
        .map((value) => {
          const category = [
            { category: "Student Task" },
            { category: "General Task" },
            { category: "Payment Overdue Task" },
          ].find(
            (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
          );
          return category
            ? {
                category: category.category,
              }
            : null;
        })
        .filter(Boolean) as CheckedCategories[];

      setCheckedCategories(selectedCategories);
    }

    if (taskFilterStartDate && taskFilterEndDate) {
      const startDate = new Date(parseInt(taskFilterStartDate));
      const endDate = new Date(parseInt(taskFilterEndDate));
      setFilterStartDate(startDate);
      setFilterEndDate(endDate);
    }

    if (
      priorityParam ||
      categoryParam ||
      taskFilterStartDate ||
      taskFilterEndDate
    ) {
      setFilterApplied(true);
    }
  }, []);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const typeParam = urlSearchParams.get("taskTypes");

    if (typeParam && tasksTypes && tasksTypes.length > 0) {
      const types = typeParam.split("|");

      const selectedTypes = types
        .map((value) => {
          const type = tasksTypes.find(
            (taskType: any) =>
              taskType.taskTypeName.toLowerCase() === value.toLowerCase(),
          );
          return type
            ? {
                type: type.taskTypeName,
              }
            : null;
        })
        .filter(Boolean) as CheckedTypes[];

      if (selectedTypes.length > 0) {
        setCheckedTypes(selectedTypes);
        setFilterApplied(true);
      }
    }
  }, [tasksTypes]);

  return (
    <Stack
      sx={{
        backgroundColor: "#fff",
        padding: "12px 24px",
      }}
    >
      <Box
        display="flex"
        flexGrow={1}
        sx={{
          justifyContent: "flex-end",
          alignItems: "center",
        }}
        className={styles.taskHeaderWrapper}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <TextField
              type="search"
              value={leadSearchTerm}
              onChange={handleLeadSearch}
              placeholder="Search Tasks"
              style={{
                padding: "0px",
                borderRadius: "4px",
                border: "none",
                outline: "none",
                height: "38px",
              }}
              size="small"
              inputProps={{
                sx: {
                  width: "250px",
                  "&::placeholder": {
                    fontWeight: "400",
                    fontSize: "12px",
                  },

                  "& .MuiOutlinedInput-input": {
                    padding: "10.5px 14px",
                  },
                },
              }}
            />
            {hasAllTaskAccess && staffList?.length > 0 && (
              <UserAvatarGroup
                handleItemSelect={handleTeamMemberSelect}
                selectedItem={selectedTeamMember}
              />
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
            }}
          >
            <Button
              onClick={handleOpen}
              color="primary"
              variant="contained"
              sx={{
                textTransform: "capitalize",
                fontSize: "14px",
                fontWeight: "400",
                color: "#FFFFFF",
                backgroundColor: "#11C89B",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#11C89B",
                },
              }}
              disabled={instituteData?.isMigrated === true ? true : false}
            >
              Add Tasks
            </Button>
            <Modal
              open={open}
              onClose={(event, reason) => {
                if (reason === "backdropClick") return;
                handleClose();
              }}
              aria-labelledby="add-task-modal"
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "background.paper",
                  borderRadius: "8px",
                  boxShadow: 24,
                  width: { xs: "95%", sm: "80%", md: "1000px" },
                  maxWidth: 900,
                  maxHeight: "90vh",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    bgcolor: "background.paper",
                    borderRadius: "8px 8px 0 0",
                    p: 3,
                    pb: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    id="add-task-modal"
                    variant="h6"
                    sx={{ ml: "20px" }}
                  >
                    Add Task
                  </Typography>
                  <IconButton
                    onClick={handleClose}
                    sx={{
                      color: "#666",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Box
                  sx={{
                    overflowY: "auto",
                    p: 3,
                    pt: 0,
                  }}
                >
                  <TaskCreation
                    CreateTask={CreateTask}
                    employees={employees && employees}
                    leadById={selectedLeadData}
                    taskTypes={taskTypes}
                    handleCancelClick={toggleShowAddTask}
                    fromTaskEdit={fromTaskEdit}
                    taskForEditing={taskForEditing}
                    EditTask={EditTask}
                    onClose={handleClose}
                  />
                </Box>
              </Box>
            </Modal>
            {(userById?.roleCode === "SUPER_ADMIN" ||
              userById?.roleCode === "ADMIN") && (
              <img
                src={Remainder}
                onClick={() => {
                  setIsOpen(true);
                  setCardType("GLOBAL");
                  setTextForReminder(
                    "You have a lot of tasks pending. Please complete it soon.",
                  );
                }}
              />
            )}
            <FilterDrawer
              handleFilterApply={handleFilterApply}
              handleResetClick={handleResetClick}
              activeFilter={filterApplied}
              cancelClick={cancelClick}
              closeSetFilter={handleFilterClose}
            >
              <div
                style={{
                  padding: "22px 32px",
                  overflowY: "auto",
                  maxHeight: "calc(100% - 110px)",
                }}
              >
                <FilterChipsWrap>
                  {checkedPriorities.length > 0 &&
                    checkedPriorities.map((item) => (
                      <FilterChips
                        key={item.priority}
                        keyVal={item.priority}
                        chipName={item.priority.toLowerCase()}
                        clearValue={item.priority}
                        closeFunction={clearCheckedPriority}
                      />
                    ))}

                  {checkedTypes.length > 0 &&
                    checkedTypes.map((item) => (
                      <FilterChips
                        key={item.type}
                        keyVal={item.type}
                        chipName={item.type.toLowerCase()}
                        clearValue={item.type}
                        closeFunction={clearCheckedType}
                      />
                    ))}

                  {checkedCategories.length > 0 &&
                    checkedCategories.map((item) => (
                      <FilterChips
                        key={item.category}
                        keyVal={item.category}
                        chipName={item.category.toLowerCase()}
                        clearValue={item.category}
                        closeFunction={clearCheckedCategory}
                      />
                    ))}
                </FilterChipsWrap>

                <FilterTypeWrap>
                  <FilterLabel labelValue="Priority" />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {[
                        { priority: "URGENT" },
                        { priority: "HIGH" },
                        { priority: "NORMAL" },
                        { priority: "LOW" },
                      ].map((item: any) => (
                        <FilterCheckbox
                          key={item.priority}
                          keyVal={item.priority}
                          checked={checkedPriorities.some(
                            (data) =>
                              data.priority.toLowerCase() ===
                              item.priority.toLowerCase(),
                          )}
                          checkboxFunction={() =>
                            handleFilterPriorityChecked(item.priority)
                          }
                          label={item.priority.toLowerCase()}
                        />
                      ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>

                <FilterTypeWrap>
                  <FilterLabel labelValue="Type" />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {tasksTypes &&
                        tasksTypes?.map((item: any) => (
                          <FilterCheckbox
                            key={item.id}
                            keyVal={item.id}
                            checked={checkedTypes.some(
                              (data) =>
                                data.type?.toLowerCase() ===
                                item?.taskTypeName?.toLowerCase(),
                            )}
                            checkboxFunction={() =>
                              handleFilterTypeChecked(item.taskTypeName)
                            }
                            label={item?.taskTypeName?.toLowerCase()}
                          />
                        ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>

                <FilterTypeWrap>
                  <FilterLabel labelValue="Category" />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {[
                        { category: "Student Task" },
                        { category: "General Task" },
                        { category: "Payment Overdue Task" },
                      ].map((item: any) => (
                        <FilterCheckbox
                          key={item.category}
                          keyVal={item.category}
                          checked={checkedCategories.some(
                            (data) =>
                              data.category.toLowerCase() ===
                              item.category.toLowerCase(),
                          )}
                          checkboxFunction={() =>
                            handleFilterCategoryChecked(item.category)
                          }
                          label={item.category.toLowerCase()}
                        />
                      ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
                <Box
                  sx={{
                    background: "#fff",
                    width: "250px",
                    zIndex: 999999,
                  }}
                  className="datepicker-container"
                >
                  <DateRangePicker
                    startDate={filterStartDate}
                    endDate={filterEndDate}
                    onDateChange={onFilterDateChange}
                    // minDate={moment().toDate()}
                  />
                </Box>
              </div>
            </FilterDrawer>
          </div>
        </div>
      </Box>
      <ClearFilter
        open={isOpenFilter}
        noButtonClick={noButtonClick}
        yesButtonClick={yesButtonClick}
        onClose={closeClearFilter}
        filteredValue={filteredValue}
      />
    </Stack>
  );
}

export default TaskKanbanHeader;
